import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import AuthContext from "../../context/auth/authContext";

const OTPScreen = () => {
  const { verifyOtp, userDetailsForOTP, userData, loading } =
    useContext(AuthContext);
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const handleSubmit = () => {
    if (otp && otp.join("").length !== 6) {
      toast.error("Wrong Entry, please enter correct OTP!", {
        autoClose: 6000,
      });
      setOtp(new Array(6).fill(""));
    } else {
      verifyOtp({ aid: userDetailsForOTP._id, code: otp.join("") });
    }
  };
  return userData?.profile_data ? (
    <></>
  ) : (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}></div>
        <div className="Register__content">
          <h2>Verify OTP</h2>
          <p>
            An OTP has been sent to your registered email.Please enter it here.
          </p>
        </div>
        <div className="Register__form">
          <center>
            <p>Enter OTP</p>
            {otp.map((data, index) => {
              return (
                <input
                  className="Register__otp-field"
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                />
              );
            })}
          </center>

          <div className="Register__footer">
            <button className="Register__button" onClick={handleSubmit}>
              Verify OTP
              {loading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPScreen;
